import logIpInfoService, {
  IpInfoServiceEndpointNames,
  IpInfoServiceStatus
} from 'services/logIpInfoService'
import Settings from 'Settings'

const IP_INFO_ENDPOINT = Settings.get('REACT_APP_IP_INFO_ENDPOINT')

interface IpInfoResponse {
  country?: string
  ip?: string
  lat?: string
  lon?: string
}

export const fetchUserIPData = async (): Promise<IpInfoResponse> => {
  logIpInfoService(
    IpInfoServiceEndpointNames.GetIpInfo,
    IpInfoServiceStatus.start,
    'info'
  )

  return fetch(IP_INFO_ENDPOINT).then(res => {
    if (!res.ok) {
      logIpInfoService(
        IpInfoServiceEndpointNames.GetIpInfo,
        IpInfoServiceStatus.error,
        'error'
      )

      throw new Error('Failed to fetch user IP')
    }

    logIpInfoService(
      IpInfoServiceEndpointNames.GetIpInfo,
      IpInfoServiceStatus.done,
      'info'
    )

    return res.json()
  })
}
